import React from 'react';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

// Mixins / Modules
import isResizable from '../../../../mixins/resizable';
import Window from '../../../../../modules/window';

// Models
import Query from '@/models/query';

// Base
import Button from '../../../../v5/base/button';
import GoogleButton from '../../../../v5/base/google_button';
import Separator from '../../../../v5/base/separator';

// Form
import Checkbox from '../../../../v5/form/checkbox';
import Input from '../../../../v5/form/input';

class SignIn extends React.Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    opportunity: PropTypes.object.isRequired,
    onSignIn: PropTypes.func.isRequired,
    onSetView: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      user: props.user,
      errorMessages: {},
      sending: false,
    }
  }

  handleInputChange = (field, value) => {
    const { user } = this.state;

    const newUser = update(
      user,
      {
        [field]: {
          $set: value,
        },
      }
    );

    this.setState({
      user: newUser,
    });
  }

  handleSubmit = (e) => {
    const {
      opportunity,
      onSignIn,
    } = this.props;

    const {
      sending,
      user,
    } = this.state;

    e && e.preventDefault();

    if (sending) return;

    this.setState(
      {
        sending: true,
      },
      () => {
        Query
          .request(
            '/users/sign_in.json',
            {
              method: 'POST',
              body: {
                user,
                opportunity_id: opportunity.id,
              },
            }
          )
          .then((response) => {
            const {
              location,
              user,
            } = response;

            onSignIn(
              location,
              user
            );
          })
          .catch((errors) => {
            const {
              responseJSON,
            } = errors;

            const message =
              responseJSON &&
                responseJSON.error
                ? responseJSON.error
                : 'Invalid email or password';

            Window.flash.error(
              errors,
              message
            );

            this.setState({
              sending: false,
            });
          });
      }
    );
  }

  handleGoogleAuth = (response) => {
    const { onSignIn } =
      this.props;

    const {
      location,
      user,
    } = response;

    onSignIn(
      location,
      user
    );
  }

  render() {
    const {
      opportunity,
      onSetView,
    } = this.props;

    const {
      user,
      sending,
    } = this.state;

    return (
      <React.Fragment>
        <div className='width-560 margin-center'>
          <img
            src={`${gon.HUBSPOT_ASSETS_URL}/oomple/assets/app/v5/layout/nav_logo.png`}
            className='height-28 margin-top-50 margin-bottom-25'
          />

          <div className='margin-bottom-10 xlg-font semi-bold line-height-26'>
            {
              opportunity.id &&
              <span>
                Login to view more jobs
              </span>
            }

            {
              !opportunity.id &&
              <span>
                Login to Your Oomple Account
              </span>
            }
          </div>

          <div className='margin-bottom-20 xxsm-font line-height-16 gray-900'>
            Find top contracts, network, and manage your work—all in one place.
          </div>

          <Separator className='margin-top-0 margin-bottom-30' />

          <div className='width-520'>
            <div className='margin-bottom-20' />

            <div className='margin-bottom-20 width-100pct flex'>
              <div className='margin-right-auto margin-left-auto'>
                <GoogleButton
                  onAuth={this.handleGoogleAuth}
                  opportunityId={opportunity.id}
                />
              </div>
            </div>

            <div className='flex justify-space-between vertical-align margin-bottom-20'>
              <div>
                <Separator className='width-155 margin-top-14 margin-bottom-14' />
              </div>

              <div>Or</div>

              <div>
                <Separator className='width-155 margin-top-14 margin-bottom-14' />
              </div>
            </div>

            <form onSubmit={this.handleSubmit}>
              <div>
                <Input
                  id='user_email'
                  label='Email address'
                  type='email'
                  onChange={
                    (_, value) =>
                      this.handleInputChange(
                        'email',
                        value
                      )
                  }
                  defaultValue={user.email}
                />
              </div>

              <div className='margin-bottom-45'>
                <Input
                  id='user_password'
                  label='Password'
                  type='password'
                  className='margin-bottom-15'
                  onChange={
                    (_, value) =>
                      this.handleInputChange(
                        'password',
                        value
                      )
                  }
                  allowPasswordToggle
                />

                <div className='flex justify-space-between'>
                  <Button
                    className='xsm-font margin-bottom-5 block'
                    text='Forgot Password?'
                    size='custom'
                    onClick={
                      () =>
                        onSetView(
                          'forgot_password'
                        )
                    }
                  />

                  <Button
                    className='xsm-font'
                    text='Resend Confirmation'
                    size='custom'
                    onClick={
                      () =>
                        onSetView(
                          'resend_confirmation'
                        )
                    }
                  />
                </div>
              </div>

              <div className='flex-grow-1'>
                <Checkbox
                  id='user_remember_me'
                  label='Remember me'
                  onChange={
                    (_, checked) =>
                      this.handleInputChange(
                        'remember_me',
                        checked
                      )
                  }
                />
              </div>

              <div>
                <Button
                  id='sign_in'
                  text='Log In'
                  onClick={this.handleSubmit}
                  className='height-48 med-font vertical-align line-height-45'
                  disabled={sending}
                  block
                />
              </div>

              <div className='margin-top-30 xsm-font'>
                New to Oomple?{' '}

                <Button
                  className='underline'
                  text='Join Now'
                  size='custom'
                  onClick={
                    () =>
                      onSetView(
                        'sign_up'
                      )
                  }
                />
              </div>

              <button
                type='submit'
                className='hide'
              />
            </form>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default isResizable(SignIn);
